import { type DropdownProps } from "semantic-ui-react";
import { useMemo } from "react";

import { useFeatureFlag } from "hooks/useFeatureFlag";
import { FeatureFlags } from "featureFlags";

import { ContentTypesEnum } from "../../../enums";
import MultiStateDropdown, { type MultiStateDropdownOption } from "../multiStateDropdown/MultiStateDropdown";
import EmbeddedVideoIcon from "components/icons/EmbeddedVideoIcon";

import { faVideoArrowUpRight } from "@fortawesome/pro-solid-svg-icons";

const embeddedOption: MultiStateDropdownOption<ContentTypesEnum> = {
  label: ContentTypesEnum.Embedded,
  renderIcon: (className?: string) => <EmbeddedVideoIcon className={className} />,
};

const uploadedOption: MultiStateDropdownOption<ContentTypesEnum> = {
  label: ContentTypesEnum.Uploaded,
  icon: faVideoArrowUpRight,
};

const getVideoOptions = (embeddedVideosEnabled: boolean): MultiStateDropdownOption<ContentTypesEnum>[] =>
  embeddedVideosEnabled ? [uploadedOption, embeddedOption] : [uploadedOption];

const getDefaultOption = (label: ContentTypesEnum) =>
  label === ContentTypesEnum.Embedded ? embeddedOption : uploadedOption;
interface VideosSegmentationDropdownProps extends DropdownProps {
  options?: MultiStateDropdownOption<ContentTypesEnum>[];
  defaultValue?: ContentTypesEnum;
}

export default function VideosSegmentationDropdown(props: VideosSegmentationDropdownProps) {
  const embeddedVideoEnabled = useFeatureFlag(FeatureFlags.EmbeddedVideos);
  const contentOptions = useMemo(() => getVideoOptions(embeddedVideoEnabled), [embeddedVideoEnabled]);

  return (
    <MultiStateDropdown
      options={contentOptions}
      defaultOption={props.defaultValue ? getDefaultOption(props.defaultValue) : contentOptions[0]}
      {...props}
    />
  );
}
